
import "../Actions/ActionRequests";
import settings from "settings";
import { REQUESTS_CHANGE_BATTLE_TYPE, REQUESTS_CHANGE_TABS, REQUESTS_CHANGE_SEASON, REQUESTS_CHANGE_SEASON_TYPE } from "../Actions/ActionRequests";

type Action = any

export type State = {};

const CLAN_ID = window.__PRELOADED_STATE__.currentAccount.clanId;

const initialState = {
  requestsBattleType: settings.defaultBattleType,
  requestsSeason: settings.ladder.lastSeasonId,
  currentRequestsTab: CLAN_ID ? 'applications' : 'invites'
};

export type IReducerRequests = (state: State, action: Action) => State;
export const ReducerRequests = (state: State = initialState, action: Action): State => {
  switch (action.type) {
    default:
      return state;

  }
};


export const requests = (state: State = initialState, action: Action) => {
  switch (action.type) {
    case REQUESTS_CHANGE_BATTLE_TYPE:
      {
        return Object.assign({}, state, {
          requestsBattleType: action.requestsBattleType
        });
      }
    case REQUESTS_CHANGE_SEASON:
      {
        return Object.assign({}, state, {
          requestsSeason: action.requestsSeason
        });
      }
    case REQUESTS_CHANGE_SEASON_TYPE:
      {
        return Object.assign({}, state, {
          requestsSeasonType: action.requestsSeasonType
        });
      }
    case REQUESTS_CHANGE_TABS:
      {
        return Object.assign({}, state, {
          currentRequestsTab: action.currentRequestsTab
        });
      }
    default:
      return state;

  }
};